import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import PlaylistAddIcon from "@material-ui/icons/PlaylistAdd";
import React from "react";
import { MenuOptionType } from "../../../../../controls";
import { Setting } from "../../models/Setting";

type Props = {
	setSettingId: Function;
	setShowDeleteModal: Function;
	setShowCreateModal: Function;
	setShowEditModal: Function;
};
export const useSettingsOptionsFunctions = ({
	setSettingId,
	setShowDeleteModal,
	setShowCreateModal,
	setShowEditModal,
}: Props) => {
	const getMenuOptions = (data: Setting) => {
		let options: MenuOptionType[] = [];
		if (!data) {
			options = options.concat([
				{
					name: "New Setting",
					key: "new_setting",
					onClick: () => {
						setShowCreateModal(true);
					},
					icon: <PlaylistAddIcon />,
				},
			]);
		} else {
			options = options.concat([
				{
					name: "New Setting",
					key: "new_setting",
					onClick: () => {
						setShowCreateModal(true);
					},
					icon: <PlaylistAddIcon />,
				},
				{
					name: "Edit Setting",
					key: "edit_setting",
					onClick: () => {
						setSettingId(data);
						setShowEditModal(true);
					},
					icon: <EditIcon />,
				},
				{
					name: "Delete Setting",
					key: "delete_setting",
					onClick: () => {
						setSettingId(data);
						setShowDeleteModal(true);
					},
					icon: <DeleteIcon />,
				},
			]);
		}
		return options;
	};
	return {
		getMenuOptions,
	};
};
